/** Perfil en CDN (slug zidneyalzauro2). */
export const ZIDNEY_PROFILE_IMAGE_URL =
  'https://files.tnonetwork.com/users/profile/zidneyalzauro2.jpeg';

export const SHOW_LOGO_3DECOPAS_URL =
  'https://files.tnonetwork.com/shows/logo/3decopas.png';

/** Cover animado (misma convención que Hero en tnonetwork.com). */
export const ANIMATED_COVER_3DECOPAS_URL =
  'https://files.tnonetwork.com/shows/animated_cover/3decopas.mp4';

export const SHOW_COVER_3DECOPAS_URL =
  'https://files.tnonetwork.com/shows/cover/3decopas.jpg';
